module.exports = __webpack_public_path__ + "img/tool6.52a105bc.png";